export default __webpack_public_path__ + "assets/padlock-component.1dbab5a1.svg";